// Export de la liste des projets en CSV ou en Excel, avec les filtres et le tri en cours. Les fiches exportées
// sont celles que la base laisse voir à l'utilisateur. Réservé aux administrateurs (règle `export` de canAccess).
import { useListContext, useLocaleState, useTranslate } from "ra-core";

import { getSupabaseClient } from "../providers/supabase/supabase";
import type { Project } from "../types";
import { ExportMenu } from "./ExportMenu";
import { MAX_EXPORT_ROWS } from "./exportLog";
import { projectExportTable } from "./projectExport";

export const ProjectExportButton = () => {
  const translate = useTranslate();
  const [locale = "fr"] = useLocaleState();
  const { getData, total, filterValues } = useListContext<Project>();

  const build = async () => {
    const [projects, { data: rates, error }] = await Promise.all([
      getData ? getData({ maxResults: MAX_EXPORT_ROWS }) : [],
      getSupabaseClient()
        .from("exchange_rates")
        .select("currency, units_per_eur"),
    ]);
    if (error) throw error;
    return projectExportTable(projects, {
      rates: Object.fromEntries(
        (rates ?? []).map((rate) => [
          rate.currency,
          Number(rate.units_per_eur),
        ]),
      ),
      translate,
      locale,
      appUrl: window.location.origin,
    });
  };

  return (
    <ExportMenu
      resource="projects"
      sheet="Projets"
      file={translate("resources.projects.export.file")}
      filters={filterValues}
      disabled={!total}
      build={build}
    />
  );
};
